import { RootState } from '../store';

export const isLoading = (state: RootState) => (loaderId: string) =>
  state.loaders.find((item) => item === loaderId) ? true : false;
